import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';

// variables
// double_1: amount requested by guest
// double_2: amount offered by agent
// double_3: final refund amount




@Component({
    selector: 'app-accounting-refund',
    templateUrl: './accounting-refund.component.html',
    styles: [],
    standalone: false
})
export class AccountingRefundComponent implements OnInit
{

	constructor() { }

	@Input() taskApi: any;
	@Input() form1: UntypedFormGroup;
	@Input() formReadOnly: Boolean;

	@Output() formTitle = new EventEmitter<string>();

	validationMessages = {
		'description': [
			{ type: 'required', message: 'Required' },
			{ type: 'maxlength', message: '250 characters maximum' }
		],

	};


	ngOnInit()
	{
		// set formTitle
		this.formTitle.emit('Refund Request');

		// add Validators
		this.form1.get('description').setValidators(Validators.required);
		this.form1.get('double_1').setValidators(Validators.required);
		this.form1.get('double_2').setValidators(Validators.required);
		this.form1.get('double_3').setValidators(Validators.required);
		this.form1.updateValueAndValidity();
	}
}
